module.exports = __webpack_public_path__ + "img/about-img7.5eb8fb7e.png";